// import { Route, Routes } from "react-router-dom"
import About from "./About"
import Contact from "./Contact"
import Home from "./Home"
import Nav from "./Nav"
import Project from "./Project"
import Skill from "./Skills"
import AOS from "aos"
import "aos/dist/aos.css"
import { useEffect } from "react"

const App = ()=>
{

  useEffect(() => 
  {
    AOS.init({
      duration: 1000,
      once: false,
    })
  }, [])


  return(
    <div className="app">
      <Nav />
      <div id="home" data-aos="fade-up"><Home /></div>
      <div id="about" data-aos="fade-down"><About /></div>
      <div id="skills" data-aos="fade-up"><Skill /></div>
      <div id="projects" data-aos="zoom-in"><Project /></div>
      <div id="contact" data-aos="fade-down"><Contact /></div>
    </div>
  )
}

export default App